import React from "react";
import AudioPlayer from "components/AudioPlayer";
import VideoPlayer from "components/VideoPlayer";
import ImageContainer from "components/ImageContainer/ImageContainer";
import MediaPreview from "components/MediaPreview/MediaPreview";
import DocumentPreview from "components/DocumentPreview";
import { extractFileName } from "utils/helpers";
import Linkify from "react-linkify";

export default ({ post }) => {
  return (
    <>
      <Linkify
        properties={{
          target: "_blank",
          style: { color: "red", fontWeight: "bold" },
        }}
      >
        <p
          className="textContent customScrollArea"
          style={{ maxHeight: "200px", overflow: "auto" }}
        >
          {post.data.content}
        </p>
      </Linkify>
      {post?.data?.media_type_id === 4 && (
        <div>
          <AudioPlayer src={post?.data?.media} />
        </div>
      )}
      {post?.data?.media_type_id === 3 && (
        <VideoPlayer
          src={post?.data?.media}
          mediaCaptions={post?.data?.media_captions?.vtt}
        />
      )}
      {post?.data?.media_type_id === 2 && (
        <MediaPreview
          attachment={post?.data?.media}
          type={post?.data?.media_type}
          typeId={post?.data?.media_type_id}
        >
          <ImageContainer
            src={post?.data?.media}
            thumb={post?.data?.media}
            alt={post?.data?.media_type}
          />
        </MediaPreview>
      )}
      {post?.data?.media_type_id === 5 && (
        <DocumentPreview
          expression={{
            media: post?.data?.media,
            media_name: extractFileName(post?.data?.media),
          }}
        />
      )}
    </>
  );
};
